var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Control/Confirm/"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.187 5.31313C18.3822 5.5084 18.3822 5.82498 18.187 6.02024L9.28032 14.9269C8.59699 15.6102 7.48912 15.6103 6.80566 14.9271L1.81326 9.93645C1.61796 9.74123 1.6179 9.42464 1.81313 9.22935C2.00836 9.03405 2.32494 9.03399 2.52024 9.22922L7.51265 14.2199C7.80555 14.5127 8.28036 14.5126 8.57321 14.2198L17.4799 5.31313C17.6751 5.11787 17.9917 5.11787 18.187 5.31313Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/Confirm.8ef8bb166d2eef6f5c122e605e33028d.svg";
export { ForwardRef as ReactComponent };